import React, { useState,useRef, useEffect } from "react";
import {
  Box, Button, Typography, Paper, Table, TableHead, TableBody, TableRow,
  TableCell, TableContainer, TablePagination, IconButton, Snackbar
} from "@mui/material";
import { Add, Edit, Delete, Undo } from "@mui/icons-material";
import OfferQuotationApp from "./OfferQuotationApp"; // 👈 import new UI
import { axiosInstances } from "./apiConfig";

export default function OfferUI() {
  const [offers, setOffers] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [total, setTotal] = useState(0);
  const deleteTimers = useRef({});
  const [pendingDeletes, setPendingDeletes] = useState({});

  const [showOfferForm, setShowOfferForm] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null); // 👈 holds offer for edit
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const loadOffers = async () => {
    try {
      const res = await axiosInstances.offerApi.get(`/?page=${page}&size=${rowsPerPage}`);
      const result = res.data.data || {};
      setOffers(result.data || []);
      setTotal(result.total || 0);
    } catch (err) {
      console.error("Error fetching offers", err);
    }
  };


  useEffect(() => {
    loadOffers();
  }, [page, rowsPerPage]);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // 👇 ADD this unified function for both Add and Edit
  const openOfferForm = (offer = null) => {
    setSelectedOffer(offer);
    setShowOfferForm(true);
  };

  const handleDelete = (id) => {
    setPendingDeletes((prev) => ({ ...prev, [id]: true }));

    deleteTimers.current[id] = setTimeout(async () => {
      try {
        await axiosInstances.offerApi.post(`/delete`, { id });
        setSnackbar({ open: true, message: "Offer deleted successfully!", severity: "success" });
        loadOffers();
      } catch (err) {
        console.error("Delete failed", err);
        setSnackbar({ open: true, message: "Something went wrong!", severity: "error" });
      } finally {
        setPendingDeletes((prev) => {
          const updated = { ...prev };
          delete updated[id];
          return updated;
        });
        deleteTimers.current[id] = null;
      }
    }, 30000);
  };

  const handleUndo = (id) => {
    if (deleteTimers.current[id]) {
      clearTimeout(deleteTimers.current[id]);
      deleteTimers.current[id] = null;
    }

    setPendingDeletes((prev) => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
  };

  if (showOfferForm) {
    return (
      <OfferQuotationApp
        offerId={selectedOffer?.id}
        offerData={selectedOffer} // 👈 pass existing offer if editing
        onCancel={() => {
          setShowOfferForm(false);
          setSelectedOffer(null);
          loadOffers(); // refresh list after closing
        }}
      />
    );
  }

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>Offer Management</Typography>

      <Button
        variant="contained"
        color="primary"
        startIcon={<Add />}
        onClick={() => openOfferForm()} // 👈 for new offer
      >
        Add Offer
      </Button>

      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sr. No.</TableCell>
              <TableCell>Offer ID</TableCell>
              <TableCell>Customer ID</TableCell>
              <TableCell>Offer No</TableCell>
              <TableCell>Offer Date</TableCell>
              <TableCell>Product IDs</TableCell>
              <TableCell>Subtotal</TableCell>
              <TableCell>Total</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {offers.map((offer, index) => (
              <TableRow key={offer.id}>
                <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                <TableCell>{offer.id}</TableCell>
                <TableCell>{offer.customer?.name || offer.customerId}</TableCell>
                <TableCell>{offer.ofrnum}</TableCell>
                <TableCell>{offer.offerDate}</TableCell>
                <TableCell>
                  {offer.productIds && offer.productIds.length > 0
                    ? offer.productIds.join(", ")
                    : "—"}
                </TableCell>
                <TableCell>{offer.subTotal}</TableCell>
                <TableCell>{offer.grandTotal}</TableCell>
                <TableCell>{offer.offer_status}</TableCell>
                <TableCell>
                  <IconButton color="primary" onClick={() => openOfferForm(offer)}>
                    <Edit />
                  </IconButton>
                  {/* <IconButton color="error" onClick={() => console.log("TODO delete offer")}>
                    <Delete />
                  </IconButton> */}
                  {pendingDeletes[offer.id] ? (
                    <IconButton color="warning" onClick={() => handleUndo(offer.id)}><Undo /></IconButton>
                  ) : (
                    <IconButton color="error" onClick={() => handleDelete(offer.id)}><Delete /></IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          count={total}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
          labelDisplayedRows={({ page }) => `Page ${page + 1} of ${Math.ceil(total / rowsPerPage)}`}
        />
      </TableContainer>
    </Box>
  );
}
